<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: pageUp.path }">{{
        pageUp.name
      }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{
        userInfo.id == undefined ? "添加员工" : "修改员工"
      }}</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form
      ref="form"
      :model="userInfo"
      :rules="addUserFormRules"
      label-width="80px"
      size="mini"
    >
      <el-row>
        <el-col :span="4">
          <el-form-item prop="username" label="账号">
            <el-input
              v-model="userInfo.username"
              placeholder="20位内字母数字下划线"
              style="width: 80%"
              :disabled="userInfo.id !== undefined"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="password" label="密码">
            <el-input
              v-model="userInfo.password"
              style="width: 80%"
              placeholder="20位内字母数字下划线"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item prop="userType" label="账号类型:">
            <el-radio v-model="userInfo.userType" label="1">管理员</el-radio>
            <el-radio v-model="userInfo.userType" label="2">普通账号</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item prop="userType" label="数据权限:">
            <el-radio v-model="userInfo.dataPermission" label="1"
              >公司级</el-radio
            >
            <el-radio v-model="userInfo.dataPermission" label="2"
              >个人级</el-radio
            >
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="accountStatus" label="账户状态:">
            <el-radio v-model="userInfo.accountStatus" label="0">正常</el-radio>
            <el-radio v-model="userInfo.accountStatus" label="1">锁定</el-radio>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="4">
          <el-form-item prop="compellation" label="姓名">
            <el-input
              v-model.trim="userInfo.compellation"
              style="width: 80%"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="sex" label="姓别:">
            <el-radio v-model="userInfo.sex" label="1">男</el-radio>
            <el-radio v-model="userInfo.sex" label="0">女</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="phone" label="手机号">
            <el-input v-model="userInfo.phone" style="width: 80%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="process" label="工序类型">
            <el-select
              v-model="userInfo.processNo"
              placeholder="请选择工序类型"
              style="width: 80%"
            >
              <el-option label="其他工序" value="0"></el-option>
              <el-option label="工序一" value="1"></el-option>
              <el-option label="工序二" value="2"></el-option>
              <el-option label="工序三" value="3"></el-option>
              <el-option label="工序四" value="4"></el-option>
              <el-option label="工序五" value="5"></el-option>
              <el-option label="工序六" value="6"></el-option>
              <el-option label="工序七" value="7"></el-option>
              <el-option label="工序八" value="8"></el-option>
              <el-option label="工序九" value="9"></el-option>
              <el-option label="工序十" value="10"></el-option>
              <el-option label="工序十一" value="11"></el-option>
              <el-option label="工序十二" value="12"></el-option>
              <el-option label="工序十三" value="13"></el-option>
              <el-option label="工序十四" value="14"></el-option>
              <el-option label="工序十五" value="15"></el-option>
              <el-option label="工序十六" value="16"></el-option>
              <el-option label="工序十七" value="17"></el-option>
              <el-option label="工序十八" value="18"></el-option>
              <el-option label="工序十九" value="19"></el-option>
              <el-option label="工序二十" value="20"></el-option>
              <el-option label="工序二十一" value="21"></el-option>
              <el-option label="工序二十二" value="22"></el-option>
              <el-option label="工序二十三" value="23"></el-option>
              <el-option label="工序二十四" value="24"></el-option>
              <el-option label="工序二十五" value="25"></el-option>
              <el-option label="工序二十六" value="26"></el-option>
              <el-option label="工序二十七" value="27"></el-option>
              <el-option label="工序二十八" value="28"></el-option>
              <el-option label="工序二十九" value="29"></el-option>
              <el-option label="工序三十" value="30"></el-option>
              <el-option label="平行工序" value="99"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="process" label="工序内容">
            <el-input
              v-model.trim="userInfo.process"
              style="width: 80%"
              :disabled="userInfo.processNo < 1"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="4">
          <el-form-item prop="workNo" label="工号">
            <el-input v-model="userInfo.workNo" style="width: 80%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="dep" label="部门">
            <el-input v-model="userInfo.dep" style="width: 80%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="education" label="学历">
            <el-input
              v-model="userInfo.education"
              style="width: 80%"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="scale" label="工资级别">
            <el-input v-model="userInfo.scale" style="width: 80%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="hiredate" label="入职日期">
            <el-date-picker
              v-model="userInfo.hiredate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 80%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="4">
          <el-form-item prop="addr" label="家庭住址">
            <el-input v-model="userInfo.addr" style="width: 80%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="homePhone" label="家庭电话">
            <el-input
              v-model="userInfo.homePhone"
              style="width: 80%"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="birthday" label="出生日期">
            <el-date-picker
              v-model="userInfo.birthday"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 80%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="idcard" label="身份证号">
            <el-input v-model="userInfo.idcard" style="width: 80%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="unitPriceOfPiecework" label="个人计件单价">
            <el-input
              v-model="userInfo.unitPriceOfPiecework"
              style="width: 80%"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-form-item prop="formulaColumn" label="计件方式">
            <el-select
              v-model="userInfo.formulaColumn"
              placeholder="请选择计件方式"
              style="width: 80%"
              @change="formulaColumnSelectChange"
            >
              <el-option
                v-for="item in formulaColumnOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
              <!-- <el-option  label="柜体面积" value="cabinetArea"></el-option>
              <el-option label="柜体面积+门板面积" value="cabinetArea,doorPlankArea"></el-option>
              <el-option label="柜体面积+门板面积+镜子垫子面积" value="cabinetArea,doorPlankArea,mirrorCushionArea"></el-option> -->
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="2">
          <div style="margin-top: 60%">页面权限</div>
          <div style="margin-top: 3%">
            <el-button size="small" @click="checkAllPagePermission">{{
              checkAllStatus == 0 ? "全选" : "取消全选"
            }}</el-button>
          </div>
          <div style="">
            <br />
            <span style="font-size: small; color: #0086b3"
              >加≡后缀的<br />为导航栏</span
            >
          </div>
        </el-col>
        <el-col :span="22">
          <el-row style="margin-top: 1%">
            <el-col :span="2">
              <span style="font-size: small">订单管理：</span>
            </el-col>
            <el-col style="margin-left: -2%" :span="20">
              <el-checkbox
                v-model="pagePermissionObj.orderNew"
                style="color: #0086b3"
                >订单新增≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.orderSubmitList"
                style="color: #0086b3"
                >订单提交≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.orderOfferList"
                style="color: #0086b3"
                >订单报价≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.modifReadyOrder"
                >修改预备订单</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.orderAuditList"
                style="color: #0086b3"
                >订单审核≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.orderAffirmList"
                style="color: #0086b3"
                >订单确认≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.productionBegan"
                >生产开始</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.orderPush"
                >订单推送</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.orderList"
                style="color: #0086b3"
                >订单列表≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.orderOutbound"
                >订单出库</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.completedConfirmation"
                >完成确认</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.abnormalSubmit"
                >异常提交</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.orderCancel"
                >订单作废</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.addAfterSaleOrder"
                >新增售后订单</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.otherCostReg"
                >其他成本登记</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.orderModifyRecord"
                >订单履历</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.orderExportExcel"
                >订单导出Excle</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.orderImportExcel"
                >订单导入Excel</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.modifOrder"
                >修改订单</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.modifOrderNo"
                >修改订单编号</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.modifOrderStatus"
                >修改订单状态</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.partsList"
                style="color: #0086b3"
                >部件清单≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.orderPushList"
                style="color: #0086b3"
                >推送列表≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.modifyList"
                style="color: #0086b3"
                >推送修改≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.delPush"
                >删除推送</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.orderReceiveList"
                style="color: #0086b3"
                >接收列表≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.acceptance"
                >批量受理</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.acceptanceOne"
                >单票受理</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.outWarehouseAcceptance"
                >出库订单受理</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.settlementApply"
                >结算申请</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.delSettlementApply"
                >删除受理</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.cancelOrderList"
                style="color: #0086b3"
                >作废订单≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.restoreOrder"
                >还原订单</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.fullyClearOrder"
                >完全清除订单</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.restoreOrderExportExcle"
                >导出作废订单</el-checkbox
              >

              <el-checkbox v-model="pagePermissionObj.importArea"
                >批量导入平米数</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.importCost"
                >批量导入成本费用</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.importLogistics"
                >批量导入物流信息</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.importPanel"
                >批量导入板件数量</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row style="margin-top: 1%">
            <el-col :span="2">
              <span style="font-size: small">售后管理：</span>
            </el-col>
            <el-col style="margin-left: -2%" :span="20">
              <el-checkbox
                v-model="pagePermissionObj.sorderTask"
                style="color: #0086b3"
                >售后任务≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sorderSubmitList"
                style="color: #0086b3"
                >售后提交≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sorderOfferList"
                style="color: #0086b3"
                >售后报价≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.acceptAfterSales"
                style="color: #0086b3"
                >受理售后≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.splitAfterSales"
                style="color: #0086b3"
                >拆单售后≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.printAfterSales"
                style="color: #0086b3"
                >打印售后≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.printCompletedAfterSales"
                style="color: #0086b3"
                >打印完成≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sorderAuditList"
                style="color: #0086b3"
                >售后审核≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sorderAffirmList"
                style="color: #0086b3"
                >售后确认≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sorderTailList"
                style="color: #0086b3"
                >跟踪列表≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sorderList"
                style="color: #0086b3"
                >售后列表≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.scancelOrder"
                style="color: #0086b3"
                >作废列表≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sorderPushList"
                style="color: #0086b3"
                >售后推送≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.smodifyList"
                style="color: #0086b3"
                >售后修改≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sorderReceiveList"
                style="color: #0086b3"
                >售后接收≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sProcessMgt"
                style="color: #0086b3"
                >售后工序≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sTransportEpiboly"
                style="color: #0086b3"
                >售后运输≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.sTransportList"
                style="color: #0086b3"
                >运输列表≡</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row style="margin-top: 1%">
            <el-col :span="2">
              <span style="font-size: small">库存管理：</span>
            </el-col>
            <el-col style="margin-left: -2%" :span="20">
              <el-checkbox
                v-model="pagePermissionObj.inventoryNew"
                style="color: #0086b3"
                >新增库存≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.inventoryList"
                style="color: #0086b3"
                >库存列表≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.inventoryListEnd"
                style="color: #0086b3"
                >完结列表≡</el-checkbox
              >
              <!-- <el-checkbox v-model="pagePermissionObj.inventoryEdit">编辑库存</el-checkbox> -->
              <el-checkbox v-model="pagePermissionObj.inventoryCancel"
                >作废库存</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.inventoryCancelList"
                style="color: #0086b3"
                >作废库存列表≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.inventoryCancelRestore"
                >还原库存</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row style="margin-top: 1%">
            <el-col :span="2">
              <span style="font-size: small">标准库存：</span>
            </el-col>
            <el-col style="margin-left: -2%" :span="20">
              <el-checkbox
                v-model="pagePermissionObj.standardInventoryNew"
                style="color: #0086b3"
                >新增库存≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.standardInventoryList"
                style="color: #0086b3"
                >库存列表≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.standardInventoryListEnd"
                style="color: #0086b3"
                >完结列表≡</el-checkbox
              >
              <!-- <el-checkbox v-model="pagePermissionObj.inventoryEdit">编辑库存</el-checkbox> -->
              <el-checkbox v-model="pagePermissionObj.standardInventoryCancel"
                >作废库存</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.standardInventoryCancelList"
                style="color: #0086b3"
                >作废库存列表≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.standardInventoryCancelRestore"
                >还原库存</el-checkbox
              >
            </el-col>
          </el-row>

          <el-row style="margin-top: 1%">
            <el-col :span="2">
              <span style="font-size: small">生产管理：</span>
            </el-col>
            <el-col style="margin-left: -2%" :span="20">
              <el-checkbox
                v-model="pagePermissionObj.addTail"
                style="color: #0086b3"
                >新增跟踪≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.processMgt"
                style="color: #0086b3"
                >工序管理≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.subProcess"
                >提交工序</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.processModif"
                style="color: #0086b3"
                >工序修改≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.warehousingMgt"
                style="color: #0086b3"
                >入库管理≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.subWarehouse"
                >提交订单入库</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row style="margin-top: 1%">
            <el-col :span="2">
              <span style="font-size: small">成品管理：</span>
            </el-col>
            <el-col style="margin-left: -2%" :span="20">
              <el-checkbox
                v-model="pagePermissionObj.finishedProductDetail"
                style="color: #0086b3"
                >成品明细≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.batchOutbound"
                >批量出库</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.outboundDetail"
                style="color: #0086b3"
                >出库明细≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.exportOutboundOrder"
                >导出出库订单</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.logisticsInfoWrite"
                >物流运输</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row style="margin-top: 1%">
            <el-col :span="2">
              <span style="font-size: small">外包管理：</span>
            </el-col>
            <el-col style="margin-left: -2%" :span="20">
              <el-checkbox
                v-model="pagePermissionObj.transportEpiboly"
                style="color: #0086b3"
                >运输外包≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.transportEpibolyReg"
                >运输外包登记</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.transportList"
                style="color: #0086b3"
                >运输列表≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.editTransportEpiboly"
                >修改运输外包</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.otherCostList"
                style="color: #0086b3"
                >其他成本≡</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row style="margin-top: 1%">
            <el-col :span="2">
              <span style="font-size: small">家装管理：</span>
            </el-col>
            <el-col style="margin-left: -2%" :span="20">
              <el-checkbox
                v-model="pagePermissionObj.decorationSub"
                style="color: #0086b3"
                >家装提交≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.decorationAudit"
                style="color: #0086b3"
                >家装审核≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.decorationAffirm"
                style="color: #0086b3"
                >家装确认≡</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.decorationList"
                style="color: #0086b3"
                >家装列表≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.decorationCancel"
                >作废家装</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.decorationCancelList"
                style="color: #0086b3"
                >作废列表≡</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row style="margin-top: 1%">
            <el-col :span="2">
              <span style="font-size: small">工资管理：</span>
            </el-col>
            <el-col style="margin-left: -2%" :span="20">
              <el-checkbox
                v-model="pagePermissionObj.pieceWorkWage"
                style="color: #0086b3"
                >计件工资≡</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row style="margin-top: 1%">
            <el-col :span="2">
              <span style="font-size: small">客户管理：</span>
            </el-col>
            <el-col style="margin-left: -2%" :span="20">
              <el-checkbox
                v-model="pagePermissionObj.pushManage"
                style="color: #0086b3"
                >推送管理≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.addPushCom"
                >添加可推送公司</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.closePush"
                >关闭推送</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.agencyInfo"
                style="color: #0086b3"
                >经销商信息≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.newAgencyInfo"
                >添加订货店铺</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.editAgencyInfo"
                >修改订货店铺</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.delAgencyInfo"
                >删除订货店铺</el-checkbox
              >
              <el-checkbox
                v-model="pagePermissionObj.customerInfo"
                style="color: #0086b3"
                >客户信息≡</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.newCustomerInfo"
                >添加客户</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.editCustomerInfo"
                >修改客户</el-checkbox
              >
              <el-checkbox v-model="pagePermissionObj.delCustomer"
                >删除客户</el-checkbox
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row style="margin-top: 2%">
        <el-col :span="4">
          <el-form-item size="large">
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    var moneyCheck = async (rule, value, cb) => {
      var isNum = /^([1-9][\d]{0,7}|0)(\.[\d]{1,3})?$/;
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !isNum.test(value)
      ) {
        return cb(new Error("请输入标准金额！"));
      }
    };
    var usernameCheck = async (rule, value, cb) => {
      var regular = /^[0-9a-zA-Z_]{1,}$/;
      if (!regular.test(value)) {
        return cb(new Error("只能使用字母数字下划线"));
      }

      if (this.userInfo.id == undefined) {
        const { data: res } = await this.$http.get(
          "/api/user/username-check/" + value
        );
        if (res.code !== 1) {
          return cb(new Error("账号已存在，请更换！"));
        }
      }
    };
    var passwordCheck = async (rule, value, cb) => {
      var regular = /^[0-9a-zA-Z_]{1,}$/;
      if (!regular.test(value)) {
        return cb(new Error("只能使用字母数字下划线"));
      }

      /* if(value.length > 20)
        {
          return cb(new Error("不能超过20位！"));
        } */
    };
    return {
      pageUp: {
        path: "/order/list",
        name: "订单列表",
      },
      userInfo: {
        username: null,
        password: null,
        compellation: null,
        dataPermission: "1",
        userType: "2",
        process: null,
        pagePermission: null,
        accountStatus: "0",
        phone: null,
        workNo: null,
        sex: "1",
        dep: null,
        education: null,
        scale: null,
        addr: null,
        homePhone: null,
        idcard: null,
        birthday: null,
        hiredate: null,
        createTime: null,
        processNo: "0",
      },
      pagePermissionObj: {
        orderNew: false,
        orderSubmitList: false,
        orderOfferList: false,
        orderAuditList: false,
        orderAffirmList: false,
        orderList: false,
        modifOrder: false,
        orderCancel: false,
        addAfterSaleOrder: false,
        otherCostReg: false,
        orderModifyRecord: false,
        partsList: false,
        orderExportExcel: false,
        orderImportExcel: false,
        abnormalSubmit: false,
        completedConfirmation: false,
        orderOutbound: false,
        modifReadyOrder: false,
        productionBegan: false,
        orderPush: false,
        orderPushList: false,
        modifyList: false,
        delPush: false,
        orderReceiveList: false,
        acceptance: false,
        acceptanceOne: false,
        outWarehouseAcceptance: false,
        settlementApply: false,
        delSettlementApply: false,
        cancelOrderList: false,
        restoreOrder: false,
        fullyClearOrder: false,
        restoreOrderExportExcle: false,
        processMgt: false,
        subProcess: false,
        processModif: false,
        warehousingMgt: false,
        subWarehouse: false,
        finishedProductDetail: false,
        batchOutbound: false,
        outboundDetail: false,
        exportOutboundOrder: false,
        logisticsInfoWrite: false,
        transportEpiboly: false,
        transportEpibolyReg: false,
        transportList: false,
        editTransportEpiboly: false,
        pushManage: false,
        addPushCom: false,
        closePush: false,
        agencyInfo: false,
        newAgencyInfo: false,
        editAgencyInfo: false,
        delAgencyInfo: false,
        customerInfo: false,
        newCustomerInfo: false,
        editCustomerInfo: false,
        delCustomer: false,
        otherCostList: false,
        modifOrderNo: false,
        modifOrderStatus: false,
        addTail: false,
        sorderTask: false,
        sorderSubmitList: false,
        sorderOfferList: false,
        sorderAuditList: false,
        sorderAffirmList: false,
        sorderTailList: false,
        sorderList: false,
        scancelOrder: false,
        sorderPushList: false,
        smodifyList: false,
        sorderReceiveList: false,
        sProcessMgt: false,
        sTransportEpiboly: false,
        sTransportList: false,
        decorationSub: false,
        decorationAudit: false,
        decorationAffirm: false,
        decorationList: false,
        decorationCancel: false,
        decorationCancelList: false,
        pieceWorkWage: false,
        inventoryNew: false,
        inventoryList: false,
        inventoryListEnd: false,
        inventoryEdit: false,
        standardInventoryNew: false,
        standardInventoryList: false,
        standardInventoryListEnd: false,
        standardInventoryEdit: false,
        standardInventoryCancel:false,
        standardInventoryCancelList: false,
        standardInventoryCancelRestore: false,
        acceptAfterSales: false,
        splitAfterSales: false,
        printAfterSales: false,
        printCompletedAfterSales: false,
        importArea: false,
        importCost: false,
        importLogistics: false,
        importPanel: false,

      },
      checkAllStatus: 0,
      addUserFormRules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { validator: usernameCheck, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: passwordCheck, trigger: "blur" },
        ],
        compellation: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        unitPriceOfPiecework: [{ validator: moneyCheck, trigger: "blur" }],
      },
      formulaColumnOptions: [
        {
          value: "cabinetArea",
          label: "柜体面积",
        },
        {
          value: "cabinetArea,doorPlankArea",
          label: "柜体面积+门板面积",
        },
        {
          value: "cabinetArea,doorPlankArea,mirrorCushionArea",
          label: "柜体面积+门板面积+镜子垫子面积",
        },
        {
          value: "boxNum",
          label: "打包数",
        },
        {
          value: "boxNum,woodNum",
          label: "打包数+打框数",
        },
      ],
    };
  },
  methods: {
    async onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          //将页面权限对象转成json字符串保存到pagePermission字段
          this.userInfo.pagePermission = JSON.stringify(this.pagePermissionObj);

          if (this.userInfo.id == undefined) {
            this.userInfo.createTime = this.getNowFormatDateTime();
            const { data: res } = await this.$http.post(
              "/api/user/add",
              this.userInfo
            );
            if (res.code == 1) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          } else {
            const { data: res } = await this.$http.post(
              "/api/user/modify",
              this.userInfo
            );
            if (res.code == 1) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          }
        } else {
          this.$message({
            message: "有必填项未填写或不合法！",
            type: "error",
          });
          return false;
        }
      });
    },
    getParams() {
      this.pageUp.path = this.$route.query.pageUpPath;
      this.pageUp.name = this.$route.query.pageUpName;
    },
    checkAllPagePermission() {
      if (this.checkAllStatus == 0) {
        this.pagePermissionObj = {
          orderNew: true,
          orderSubmitList: true,
          orderOfferList: true,
          orderAuditList: true,
          orderAffirmList: true,
          orderList: true,
          modifOrder: true,
          orderCancel: true,
          addAfterSaleOrder: true,
          otherCostReg: true,
          orderModifyRecord: true,
          partsList: true,
          orderExportExcel: true,
          orderImportExcel: true,
          abnormalSubmit: true,
          completedConfirmation: true,
          orderOutbound: true,
          modifReadyOrder: true,
          productionBegan: true,
          orderPush: true,
          orderPushList: true,
          modifyList: true,
          delPush: true,
          orderReceiveList: true,
          acceptance: true,
          acceptanceOne: true,
          outWarehouseAcceptance: true,
          settlementApply: true,
          delSettlementApply: true,
          cancelOrderList: true,
          restoreOrder: true,
          fullyClearOrder: true,
          restoreOrderExportExcle: true,
          processMgt: true,
          subProcess: true,
          processModif: true,
          warehousingMgt: true,
          subWarehouse: true,
          finishedProductDetail: true,
          batchOutbound: true,
          outboundDetail: true,
          exportOutboundOrder: true,
          logisticsInfoWrite: true,
          transportEpiboly: true,
          transportEpibolyReg: true,
          transportList: true,
          editTransportEpiboly: true,
          pushManage: true,
          addPushCom: true,
          closePush: true,
          agencyInfo: true,
          newAgencyInfo: true,
          editAgencyInfo: true,
          delAgencyInfo: true,
          customerInfo: true,
          newCustomerInfo: true,
          editCustomerInfo: true,
          delCustomer: true,
          otherCostList: true,
          modifOrderNo: true,
          modifOrderStatus: true,
          addTail: true,
          sorderTask: true,
          sorderSubmitList: true,
          sorderOfferList: true,
          sorderAuditList: true,
          sorderAffirmList: true,
          sorderTailList: true,
          sorderList: true,
          scancelOrder: true,
          sorderPushList: true,
          smodifyList: true,
          sorderReceiveList: true,
          sProcessMgt: true,
          sTransportEpiboly: true,
          sTransportList: true,
          decorationSub: true,
          decorationAudit: true,
          decorationAffirm: true,
          decorationList: true,
          decorationCancel: true,
          decorationCancelList: true,
          pieceWorkWage: true,
          standardInventoryNew: true,
          standardInventoryList: true,
          standardInventoryListEnd: true,
          standardInventoryEdit: true,
          acceptAfterSales: true,
          splitAfterSales: true,
          printAfterSales: true,
          printCompletedAfterSales: true,
          importArea: true,
          importCost: true,
          importLogistics: true,
          importPanel: true,
        //  修复全选未能选择的问题
          inventoryNew: true,
          inventoryList: true,
          inventoryListEnd: true,
          inventoryCancel: true,
          inventoryCancelList: true,
          inventoryCancelRestore: true,
          standardInventoryCancel:true,
          standardInventoryCancelList: true,
          standardInventoryCancelRestore: true,

        };

        this.checkAllStatus = 1;
      } else {
        this.pagePermissionObj = {
          orderNew: false,
          orderSubmitList: false,
          orderOfferList: false,
          orderAuditList: false,
          orderAffirmList: false,
          orderList: false,
          modifOrder: false,
          orderCancel: false,
          addAfterSaleOrder: false,
          otherCostReg: false,
          orderModifyRecord: false,
          partsList: false,
          orderExportExcel: false,
          orderImportExcel: false,
          abnormalSubmit: false,
          completedConfirmation: false,
          orderOutbound: false,
          modifReadyOrder: false,
          productionBegan: false,
          orderPush: false,
          orderPushList: false,
          modifyList: false,
          delPush: false,
          orderReceiveList: false,
          acceptance: false,
          acceptanceOne: false,
          outWarehouseAcceptance: false,
          settlementApply: false,
          delSettlementApply: false,
          cancelOrderList: false,
          restoreOrder: false,
          fullyClearOrder: false,
          restoreOrderExportExcle: false,
          processMgt: false,
          subProcess: false,
          processModif: false,
          warehousingMgt: false,
          subWarehouse: false,
          finishedProductDetail: false,
          batchOutbound: false,
          outboundDetail: false,
          exportOutboundOrder: false,
          logisticsInfoWrite: false,
          transportEpiboly: false,
          transportEpibolyReg: false,
          transportList: false,
          editTransportEpiboly: false,
          pushManage: false,
          addPushCom: false,
          closePush: false,
          agencyInfo: false,
          newAgencyInfo: false,
          editAgencyInfo: false,
          delAgencyInfo: false,
          customerInfo: false,
          newCustomerInfo: false,
          editCustomerInfo: false,
          delCustomer: false,
          otherCostList: false,
          modifOrderNo: false,
          modifOrderStatus: false,
          addTail: false,
          sorderTask: false,
          sorderSubmitList: false,
          sorderOfferList: false,
          sorderAuditList: false,
          sorderAffirmList: false,
          sorderTailList: false,
          sorderList: false,
          scancelOrder: false,
          sorderPushList: false,
          smodifyList: false,
          sorderReceiveList: false,
          sProcessMgt: false,
          sTransportEpiboly: false,
          sTransportList: false,
          decorationSub: false,
          decorationAudit: false,
          decorationAffirm: false,
          decorationList: false,
          decorationCancel: false,
          decorationCancelList: false,
          pieceWorkWage: false,
          standardInventoryNew: false,
          standardInventoryList: false,
          standardInventoryListEnd: false,
          standardInventoryEdit: false,
          acceptAfterSales: false,
          splitAfterSales: false,
          printAfterSales: false,
          printCompletedAfterSales: false,
          importArea: false,
          importCost: false,
          importLogistics: false,
          importPanel: false,
        };

        this.checkAllStatus = 0;
      }
    },
    async getUserInfo(userId) {
      const { data: res } = await this.$http.get("/api/user/get-one/" + userId);
      if (res.code == 1) {
        this.userInfo = res.data;
        this.userInfo.userType = this.userInfo.userType.toString();
        this.userInfo.dataPermission = this.userInfo.dataPermission.toString();
        this.userInfo.accountStatus = this.userInfo.accountStatus.toString();
        this.userInfo.sex = this.userInfo.sex.toString();

        this.userInfo.processNo =
          this.userInfo.processNo == null
            ? "0"
            : this.userInfo.processNo.toString();

        this.pagePermissionObj = JSON.parse(this.userInfo.pagePermission);
      }
    },
    formulaColumnSelectChange(item) {
      for (let i = 0; i < this.formulaColumnOptions.length; i++) {
        if (this.formulaColumnOptions[i].value == item) {
          this.userInfo.formulaExplain = this.formulaColumnOptions[i].label;
        }
      }
    },
  },

  created() {
    this.getParams();
    if (this.$route.query.userId != undefined) {
      this.getUserInfo(this.$route.query.userId);
    }
  },
};
</script>

<style></style>
